import React from 'react';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const SpeedDialActions = ({ onNavigate }) => {
  const actions = [
    {
      key: 'view-clients',
      icon: <PeopleAltIcon />,
      tooltipTitle: 'Manage Clients',
      onClick: () => onNavigate('/clients'),
      backgroundColor: '#ed6c02',
      hoverColor: '#e65100',
    },
    {
      key: 'new-client',
      icon: <PersonAddIcon />,
      tooltipTitle: 'New Client',
      onClick: () => onNavigate('/clients/new'),
      backgroundColor: '#1976d2',
      hoverColor: '#1565c0',
    },
  ];

  return (
    <SpeedDial
      ariaLabel="Quick Actions"
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        '& .MuiSpeedDial-fab': {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
          },
        },
      }}
      icon={<SpeedDialIcon icon={<AddIcon />} />}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.key}
          icon={action.icon}
          tooltipTitle={action.tooltipTitle}
          onClick={action.onClick}
          sx={{
            '& .MuiSpeedDialAction-fab': {
              backgroundColor: action.backgroundColor,
              '&:hover': {
                backgroundColor: action.hoverColor,
              },
            },
          }}
        />
      ))}
    </SpeedDial>
  );
};

export default SpeedDialActions;
